module.exports = __webpack_public_path__ + "img/sunny.99681bb1.png";